
import { Vue, Options } from 'vue-class-component'
import { getUrlModalOptionsMyCoupon, modalOptionsCouponBZB } from '@/model/modal-options.model'
import { useStore } from '@/store'
import { FreeMode } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import 'swiper/swiper-bundle.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import { MyCoupon } from '@/model/my-coupon.model'
import { mappingImageDefault } from '@/helpers/mapper'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'
import { PartnerOffersList } from '@/interfaces/my-coupon'

library.add(faChevronRight)

@Options({
  components: {
    Swiper,
    SwiperSlide,
    FontAwesomeIcon,
    QSkeleton
  },
  computed: {
    isLoading() {
      return this.$store.state.myCouponInfo.partnerOffers.isLoading
    },
    offersList() {
      return this.$store.state.myCouponInfo.partnerOffers.items
    },
    customerType() {
      return this.$store.state.customer?.customerType
    }
  }
})
export default class SpecialStore extends Vue {
  store = useStore()
  modules = [FreeMode]
  textTitleName = MyCoupon.COUPON_LIFESTYLE_TITLE
  textViewAll = MyCoupon.VIEW_ALL

  isGoldCoupon(coupon: PartnerOffersList | undefined): boolean {
    const userFlags = coupon?.UserFlag ?? []
    return userFlags.length > 0 && userFlags.some((flag: string) => flag.split('|').some(f => f.trim().toUpperCase() === 'GOLD'))
  }

  getImage(image: string) {
    return mappingImageDefault(image)
  }

  errorImage(event: any) {
    event.target.onerror = null
    event.target.src = require('../../assets/img/coupon-image-placeholder.png')
    event.target.className = 'special-store-detail-img-default'
  }

  handleRedirectApp(offer?: PartnerOffersList) {
    this.updateGAEvent(offer)
    const query = this.$route?.query

    if(query['is_disabled_deeplink'] !== 'true') {
        window.location.href = process.env.VUE_APP_DOWNLOAD_LOTUSS!
    }
  }

  openModalOffer(offer?: PartnerOffersList) {
    const myCouponToken = this.store.state.lineInfo.idToken
    const offerID = offer?.ID ? offer.ID : ''
    const customerType = this.store.state.customer?.customerType ?? undefined
    const socialToken = this.store.state.lineInfo?.socialToken ?? undefined
    const url = getUrlModalOptionsMyCoupon(offerID, 'lifestyle', 'offer', 'all', customerType, socialToken)
    modalOptionsCouponBZB.url = `${url}${offerID ? '&action=back-to-line-web' : ''}&token=${myCouponToken}`
    
    this.store.commit('modalIframe/updateModalIframeActive', true)
    this.store.commit('modalIframe/updateModalOptionsIframe', modalOptionsCouponBZB)

    this.updateGAEvent(offer)
  }

  updateGAEvent(offer?: PartnerOffersList) {
    const customerType = this.store.state.customer?.customerType
    let objEvent = {}
    if (offer?.ID) {
      objEvent = {
        event: 'mylotuss_coupon_card',
        topic_section: 'offers_special_store',
        component: 'special-store-slide',
        coupon_section: offer?.Name,
        coupon_type: offer?.Type,
        coupon_scope: customerType
      }
    } else {
      objEvent = {
        event: 'mylotuss_see_all',
        topic_section: 'offers_special_store',
        component: 'special-store-title-view-all'
      }
    }
    addGAEvent(objEvent)
  }
}
